

export default class FinalResultCalculator {

    public static readonly POINTS_THRESHOLD_YIELD: number = 2;

    constructor(private projectScore: number,
                private isMinimumCompleted: boolean,
                private examScore: number | undefined,
                private bonusOrPenaltyPoints: number,
                private repoName: string,
                private completedTags: string[]) {
    }

    public gradeFinalGrade(): number | undefined {
        if (!this.isMinimumCompleted || this.examScore === undefined) {
            return undefined;
        }

        const gradeWithoutBonuses = this.getGradeForPoints(this.getTotalPointsWithoutBonuses());
        const gradeWithBonuses = this.getGradeForPoints(this.getTotalPoints());

        const grade = gradeWithoutBonuses === 0
            ? 0
            : Math.max(gradeWithBonuses, 1); // do not fail because of penalty points

        if (this.repoName === 'icd0007' && !this.completedTags.includes('hw5')) {
            return Math.min(3, grade);
        } else if (this.repoName === 'icd0007' && !this.completedTags.includes('hw6')) {
            return Math.min(4, grade);
        } else if (this.repoName === 'icd0011' && !this.completedTags.includes('hw09')) {
            return Math.min(3, grade);
        } else if (this.repoName === 'icd0011' && !this.completedTags.includes('hw10')) {
            return Math.min(4, grade);
        } else if (this.repoName === 'icd0019' && !this.completedTags.includes('ex11')) {
            return Math.min(3, grade);
        } else if (this.repoName === 'icd0019' && !this.completedTags.includes('ex12')) {
            return Math.min(4, grade);
        }

        return grade;
    }

    private getGradeForPoints(points: number) {
        const yieldPoints = FinalResultCalculator.POINTS_THRESHOLD_YIELD;

        for (const tuple of [[51, 1], [61, 2], [71, 3], [81, 4], [91, 5]].reverse()) {
            if (points >= tuple[0] - yieldPoints) {
                return tuple[1];
            }
        }
        return 0;
    }

    getTotalPoints(): number {
        return this.getTotalPointsWithoutBonuses() + this.bonusOrPenaltyPoints;
    }

    getTotalPointsWithoutBonuses(): number {
        return this.projectScore + (this.examScore || 0);
    }

}
